// angular
// 	.module("HeroPRO")
// 	.controller("ApplicationMessageController", ApplicationMessageController);

import _ from 'lodash';
import './applicationMessage.scss';

/* @ngInject */
export default function ApplicationMessageController(FRInformationFactory, UserData, HPAppDetailTypes) {
    const vm = this;
    vm.appInfo = {};
    vm.showMessage = true;
    vm.message = { header: '', text: '' };


    vm.init = function () {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.appInfo = FRInformationFactory.getAppInfo();
            vm.applicationMessages();
        });
    };


    vm.applicationMessages = function () {
        UserData.getCurrentLocation().then((locationDataResponse) => {
            // Check if the organization has a buydown rate
            const buydownTermSets = _.findWhere(locationDataResponse.OrganizationTermSets, { TermSetTypeId: HPAppDetailTypes.TermSetTypes.BuyDown });
            // if (buydownTermSets !== undefined) {
            //     // Check if the property address belongs to a program that has mattherhorn term set rates
            //     if (_.findWhere(locationDataResponse.OrganizationTermSets, { ProgramId: vm.appInfo.ProgramId } !== undefined)) {
            //         vm.setMatterhornMessage();
            //     } else {
            //         vm.setNonMatterhorn();
            //     }
            // }
        });
    };

    vm.setNonMatterhorn = function () {
        vm.message.header = 'Standard HERO rates apply on this home.';
        vm.message.text = 'For rate details, contact your account manager.';
        vm.message.class = 'col-md-12 app-message warn';
        vm.showMessage = true;
    };

    vm.setMatterhornMessage = function () {
        vm.message.header = 'Good news! Promotional rates apply on this home.';
        vm.message.text = 'For rate details, contact your account manager.';
        vm.message.class = 'col-md-12 app-message good';
        vm.showMessage = true;
    };

    vm.init();
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/application/applicationMessageController.js